import React from 'react';
import Seo from '../../components/Seo';

function CondicionesUso() {
  return (
    <div className="page page--narrow">
      <Seo title="Condiciones de uso" />
      <h1>Condiciones de uso</h1>
      <p>
        El acceso y uso de librosparaviajeros.es atribuye la condición de usuario e implica la aceptación de
        estas condiciones. Pendiente de completar con el texto legal definitivo (propiedad intelectual del
        contenido, uso permitido, responsabilidad sobre enlaces externos y comentarios si se habilitan).
      </p>
    </div>
  );
}

export default CondicionesUso;
